module.exports = __webpack_public_path__ + "img/spelo.7c050de3.svg";